/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

exports.onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') {
    return;
  }

  // Scroll to top on route change
  window.scrollTo(0, 0);

  if (window.plausible) {
    try {
      window.plausible('pageview', {
        u: `${window.location.origin}${location?.pathname || ''}`,
      });
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('Plausible pageview tracking failed', error);
      }
    }
  }
};
